import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

import { Game, Firebase } from '../../../Core'

import * as selectors from '../ranking.selectors'

import FederationFlag from '../../Components/FederationFlag'
import UserShield from '../../Components/UserShield'
import * as utils from '../../Ranking/ranking.utils'

/**
 *  Main ranking view
 */
class FederationRanking extends React.Component {
  /****/
  constructor(props) {
    super(props)
    this.state = {
      growOutClass: '',
    }
  }

  removeRanking() {
    const { removeScreen } = this.props
    this.setState({ growOutClass: 'bounceOut-animation' })

    setTimeout(() => {
      removeScreen('federation_ranking')
    }, 1000)
  }

  renderFederationInfo() {
    const { federation } = this.props
    let fixedPoints =
      isNaN(federation.points) || federation.points == undefined ? 0 : federation.points.toFixed(2)
    return (
      <div className="federation--head">
        <div className="federation--head__info">
          <FederationFlag flag={federation.flag} />
          <div className="info">
            <div className="name">{federation.name}</div>
            <div className="colognes">
              <span>{fixedPoints}</span>
              <span className="icon-colonos"></span>
            </div>
          </div>
        </div>
        <span onClick={() => this.removeRanking()} className="icon-cross">
          {' '}
        </span>
      </div>
    )
  }

  renderUsers(user) {
    const { currentUser, rankingObfuscated } = this.props

    const activeClass = currentUser.id == user.licenseId ? 'active' : ''
    let obfuscated = rankingObfuscated == 'undefined' ? 'normal' : rankingObfuscated
    let name =
      obfuscated == 'obfuscated'
        ? utils.obfuscated(user.name, currentUser)
        : obfuscated == 'alias'
        ? user.name == currentUser.name
          ? user.name
          : user.alias
        : user.name
    return (
      <li key={user.position} className={`federation--members__list--item ${activeClass}`}>
        <div className="info">
          <div className="position">{user.position}</div>
          <UserShield shield={user.colonyShield} />
          <div className="name">{name}</div>
        </div>
        <div className="colognes">
          <span>{user.settlers}</span>
          <span className="icon-colonos"></span>
        </div>
      </li>
    )
  }

  /**
   *  Render component
   */
  render() {
    const { federationRanking } = this.props
    const { growOutClass } = this.state

    return (
      <div className={`container`}>
        <div className="content">
          <div
            className={`federation--members ${
              growOutClass != '' ? growOutClass : 'growIn-animation'
            }`}
          >
            {this.renderFederationInfo()}
            <ul className="federation--members__list">
              {federationRanking.map((user) => this.renderUsers(user))}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  federationRanking: selectors.getRankingInFederation(state),
  federation: selectors.getSelectedFederation(state),
  currentUser: Firebase.selectors.getUserData(state),
  rankingObfuscated: Firebase.selectors.getObfuscatedRankingFlag(state),
})

const mapDispatchToProps = (dispatch) => ({
  removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
})

FederationRanking.propTypes = {
  federation: PropTypes.object,
  currentUser: PropTypes.object,
  federationRanking: PropTypes.array,
  removeScreen: PropTypes.func,
  rankingObfuscated: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(FederationRanking))
